"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProvidersList = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const filter_header_1 = require("client/components/filter-header");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const button_1 = require("client/components/material/button");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const floating_page_1 = require("client/components/page/floating-page");
const router_1 = require("client/components/router");
const upload_modal_1 = require("client/components/upload-modal");
const store_1 = require("client/modules/app-settings/store");
const edit_provider_1 = require("client/modules/providers/modules/providers-list/components/edit-provider");
const store_2 = require("client/modules/sites/modules/sites-list/store");
const store_3 = require("client/modules/users/store");
const Add_1 = require("material-ui-icons/Add");
const Notifications_1 = require("material-ui-icons/Notifications");
const Publish_1 = require("material-ui-icons/Publish");
const Warning_1 = require("material-ui-icons/Warning");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const ramda_1 = require("ramda");
const React = require("react");
const react_1 = require("react");
const ReactTooltip = require("react-tooltip");
const app_settings_1 = require("shared/app-settings");
const capitalize_string_1 = require("shared/util/capitalize-string");
const throttle_debounce_1 = require("throttle-debounce");
const store_4 = require("../../store");
require("./providers-list.less");
const text_field_small_1 = require("client/components/material/text-field/text-field-small");
const columns = [
    {
        label: "Name",
        id: "provider.lastName"
    },
    {
        label: "Pharmacy Name",
        id: "site.displayName"
    },
    {
        label: "Npi",
        id: "provider.npiNumber"
    },
    {
        label: "Dea",
        id: "provider.dea"
    },
    {
        label: "Dea Exp",
        id: "provider.deaExp"
    },
    {
        label: "State Lic",
        id: "provider.stateLicense"
    },
    {
        label: "State Lic Exp",
        id: "provider.stateLicenseExp"
    },
    {
        label: "",
        id: "provider.id"
    },
    {
        label: "",
        id: "provider.id"
    },
    {
        label: "",
        id: "provider.id"
    }
];
const today = new Date(); // new Date().toString() to new Date()
const dummyProvider = {
    email: "",
    firstName: "",
    lastName: "",
    prefix: "",
    suffix: "",
    id: 0,
    phone: "",
    dea: "",
    // deaExp: today,
    deaExp: null,
    npiNumber: "",
    state: "",
    stateLicense: "",
    // stateLicenseExp: today,
    stateLicenseExp: null,
    title: ""
};
let ProvidersList = class ProvidersList extends react_1.Component {
    constructor() {
        super(...arguments);
        this.confirmDeleteProvider = null;
        this.confirmUploadProvider = null;
        this.sortedBy = {
            label: "",
            value: ""
        };
        this.editId = -1;
        this.daysPrior = 0;
        this.routeId = -1;
        this.currentRowIndex = -1;
        this.isCollapse = true;
        this.sortMenu = false;
        this.order = "ASC";
        this.orderBy = "provider.lastName";
        this.showUpload = false;
        this.filterText = "";
        this.autoFocusForm = true;
        this.uploadModal = false;
        this.provider = ramda_1.merge(dummyProvider, {});
        this.showDisabled = false;
        // C-097 provider
        this.page = 1;
        this.limit = 25;
        this.totalPages = 1;
        this.loadProviders = throttle_debounce_1.debounce(200, () => {
            const options = {
                count: 100,
                order: this.order,
                search: this.filterText,
                start: 0,
                where: "",
                sort: this.orderBy,
                showDisabled: this.showDisabled,
                page: this.page,
                limit: this.limit // C-097 provider
            };
            store_4.providersStore.loadProviders(options);
        });
        // C-097 provider
        this.loadStartProviders = throttle_debounce_1.debounce(200, () => {
            const options = {
                count: 100,
                order: this.order,
                search: this.filterText,
                start: 0,
                where: "",
                sort: this.orderBy,
                showDisabled: this.showDisabled,
                page: 1,
                limit: this.limit //For pagination // C-097.271
            };
            store_4.providersStore.loadProviders(options);
        });
        // endregion
        this.onHandleClickRow = (row, index) => {
            if (this.editId === row.id) {
                this.isCollapse = !this.isCollapse;
                this.autoFocusForm = true;
            }
            else {
                this.isCollapse = false;
            }
            this.editId = row.id;
            this.currentRowIndex = index;
            router_1.RouteManager.transitionTo(`/providers/${row.id}`);
        };
        this.onHandleClickAddProvider = () => {
            router_1.RouteManager.transitionTo(`/providers/0`);
        };
        this.onHandleClickDeleteProvider = (provider) => {
            this.confirmDeleteProvider = provider;
        };
        this.onHandleClickConfirmDeleteProvider = () => {
            if (this.confirmDeleteProvider) {
                store_4.providersStore.deleteProvider(this.confirmDeleteProvider);
                this.confirmDeleteProvider = null;
            }
        };
        this.onHandleClickCancelDeleteProvider = () => {
            this.confirmDeleteProvider = null;
        };
        this.onHandleCredentialUpload = (provider) => {
            this.confirmUploadProvider = provider;
            this.uploadType = "credential";
            this.uploadModal = true;
        };
        this.onHandleImageUpload = (provider) => {
            this.confirmUploadProvider = provider;
            this.uploadType = "image";
            this.uploadModal = true;
        };
        this.onHandleClickDeleteUpload = async (upload) => {
            await store_4.providersStore.deleteUpload(upload);
        };
        this.onHandleClickCancelUpload = () => {
            this.uploadModal = false;
        };
        this.onMouseEnter = () => {
            this.showUpload = true;
        };
        this.onMouseLeave = () => {
            this.showUpload = false;
        };
        this.onHandleSave = async (provider) => {
            this.provider = provider;
            let newProvider;
            if (provider.id) {
                newProvider = await store_4.providersStore.saveProvider(provider);
            }
            else {
                newProvider = await store_4.providersStore.createProvider(provider);
            }
            if (newProvider) {
                router_1.RouteManager.transitionTo(`/providers/${newProvider.id}`);
                this.loadProviders();
            }
        };
        this.onCallback = (value) => {
            this.autoFocusForm = false;
            this.filterText = value;
            this.loadProviders();
        };
        this.handleAssetsUpload = async (accepted) => {
            await store_4.providersStore.upload(accepted, String(this.editId), this.uploadType);
            router_1.RouteManager.transitionTo(`/providers/${this.editId}`);
        };
        this.handleDisabledToggle = () => {
            this.showDisabled = !this.showDisabled;
            this.page = 1; // 28/01/2025 missing icon 
            this.loadProviders();
        };
        // C-097 handle pagination input
        this.handleKeyDown = () => {
            if (this.page === Number(""))
                return;
            (this.page !== store_4.providersStore.currentPage) && this.loadProviders();
        };
        this.renderListRowEditMode = (row, index) => (React.createElement("div", { key: -1 }, !this.isCollapse && (this.editId === row.id || this.routeId === row.id) && (React.createElement(edit_provider_1.EditProvider, { autoFocusForm: this.autoFocusForm, error: store_4.providersStore.editProvider.error, key: index, loading: store_4.providersStore.editProvider.loading, onCancel: () => {
                this.editId = -1;
                router_1.RouteManager.transitionTo("/providers");
                store_4.providersStore.editProvider.error = undefined;
            }, onDelete: this.onHandleClickDeleteProvider, onDeleteUpload: this.onHandleClickDeleteUpload, onCredentialUpload: this.onHandleCredentialUpload, onImageUpload: this.onHandleImageUpload, onSave: this.onHandleSave, provider: row, status: store_4.providersStore.editProvider.status, newProvider: false }))));
        this.renderEditNewProvider = () => (React.createElement("div", { className: "providers__new-provider" },
            React.createElement(edit_provider_1.EditProvider, { autoFocusForm: this.autoFocusForm, error: store_4.providersStore.editProvider.error, loading: store_4.providersStore.editProvider.loading, onCancel: () => {
                    router_1.RouteManager.transitionTo("/providers");
                    store_4.providersStore.editProvider.error = undefined;
                }, onSave: this.onHandleSave, provider: this.provider, status: store_4.providersStore.editProvider.status, newProvider: true })));
        this.renderListRow = (row, index) => {
            let siteName = "";
            if (row.sites &&
                row.sites.length &&
                (row.sites[0].displayName || row.sites[0].name)) {
                siteName = row.sites[0].displayName || row.sites[0].name;
            }
            const deaExp = row.deaExp
                ? moment(row.deaExp).format("MMM DD, YYYY")
                : null;
            const stateExp = moment(row.stateLicenseExp).format("MMM DD, YYYY");
            const displayName = row.lastName && row.firstName
                ? `${row.lastName}, ${row.firstName}`
                : `${row.firstName} ${row.lastName}`;
            if (row.sites.length > 1) {
                siteName += ` (and ${row.sites.length - 1} other${row.sites.length > 2 ? "s" : ""})`;
            }
            const today = moment().startOf("day");
            const alertDateDEA = moment(row.deaExp)
                .subtract(this.daysPrior, "days")
                .startOf("day")
                .toString();
            const alertDateState = moment(row.stateLicenseExp)
                .subtract(this.daysPrior, "days")
                .startOf("day")
                .toString();
            const showAlertDEA = today.isBetween(alertDateDEA, row.deaExp);
            const showAlertState = today.isBetween(alertDateState, row.stateLicenseExp);
            const deaExpired = today.isSameOrAfter(row.deaExp);
            const stateExpired = today.isSameOrAfter(row.stateLicenseExp);
            const isExpired = today.isSameOrAfter(row.deaExp) ||
                today.isSameOrAfter(row.stateLicenseExp);
            const uploadswithExpdate = row.uploads.filter(upload => upload.expDate !== null);
            let assetExpired = false;
            for (const item of uploadswithExpdate) {
                const expDate = moment(item.expDate);
                assetExpired = today.isSameOrAfter(expDate);
                if (assetExpired) {
                    break;
                }
            }
            let assetExpiring = false;
            for (const item of uploadswithExpdate) {
                const expDate = moment(item.expDate);
                const alertDateAsset = moment(item.expDate)
                    .subtract(this.daysPrior, "days")
                    .startOf("day")
                    .toString();
                assetExpiring = today.isBetween(alertDateAsset, expDate);
                if (assetExpiring) {
                    break;
                }
            }
            const missingRequiredAssetsforProvArray = this.missingRequiredAssets &&
                this.missingRequiredAssets.length &&
                this.missingRequiredAssets.filter((asset) => asset.id === row.id);
            const rowUploadsArray = row.uploads.map((upload) => upload.connectAssetId);
            //  if rowUploadsArray contains the ids or the assetsArray then it should not have a warning, and missing will be empty
            const missing = missingRequiredAssetsforProvArray &&
                missingRequiredAssetsforProvArray.length &&
                missingRequiredAssetsforProvArray[0].assetsArray &&
                missingRequiredAssetsforProvArray[0].assetsArray.length &&
                missingRequiredAssetsforProvArray[0].assetsArray.filter((num) => num && !rowUploadsArray.includes(num.id));
            let missingRequired = false;
            if (missingRequiredAssetsforProvArray &&
                missingRequiredAssetsforProvArray.length &&
                missingRequiredAssetsforProvArray[0].assetsArray &&
                missingRequiredAssetsforProvArray[0].assetsArray.length > 0 &&
                missing &&
                missing.length > 0) {
                missingRequired = true;
            }
            const providerName = displayName;
            const normalizedSiteName = siteName;
            const deleted = row.deletedAt;
            return [
                React.createElement(list_item_1.MaterialListItem, { className: deleted
                        ? "disabled-site-accent"
                        : isExpired || assetExpired
                            ? "expired-license-accent"
                            : "", key: index, onClick: () => {
                        this.onHandleClickRow(row, index);
                    } },
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(providerName) }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(normalizedSiteName) }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: row.npiNumber }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: row.dea }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: deaExp, label: deaExpired && "DEA Expired" }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: row.stateLicense }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: stateExp, label: stateExpired && "License Expired" }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: showAlertDEA || showAlertState ? (React.createElement(Warning_1.default, { className: "warning-quantity--icon", "data-place": "right", "data-tip": "Provider's credential (License/DEA) is expiring soon.", "data-for": "warning-icon", fill: "#eeb20d" })) : null }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: assetExpiring ? (React.createElement(Warning_1.default, { className: "warning-quantity--icon", "data-place": "right", "data-tip": "Certification/Training is expiring soon.", "data-for": "warning-icon", fill: "#eeb20d" })) : null }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: missingRequired ? (React.createElement(Notifications_1.default, { className: "warning-quantity--icon", "data-tip": "Missing required certifications.", "data-place": "right", "data-for": "warning-icon", fill: "#eeb20d" })) : null })),
                this.renderListRowEditMode(row, index)
            ];
        };
        this.allAssignedPharmacyProviders = []; //B-062.2
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.loadProviders();
        };
        // endregion
    }
    // region React methods
    componentWillMount() {
        ReactTooltip.rebuild();
        // sitesListStore.loadSites();
        store_2.sitesListStore.loadSitesNoRelation();
        this.routeId = Number(this.props.params[0]);
        if (this.routeId > 0) {
            this.isCollapse = false;
        }
    }
    async componentDidMount() {
        await store_4.providersStore.loadProviders();
        const daysSetting = await store_1.appSettingsStore.readSettings(app_settings_1.AppOption.DaysPriorProvExpLicense);
        this.daysPrior = Number(daysSetting.value);
        const providers = store_4.providersStore.providers.value;
        // C-097 provider
        this.totalPages = store_4.providersStore.totalProviderPage;
        this.page = store_4.providersStore.currentPage;
        const missingRequiredAssetsArray = await store_4.providersStore.getMissingRequiredAssets(providers, "provider");
        this.missingRequiredAssets = missingRequiredAssetsArray
            ? Array.from(missingRequiredAssetsArray)
            : [];
        ReactTooltip.rebuild();
    }
    // 28/01/2025 missing icon 
    async getIconProvider() {
        const providers = store_4.providersStore.providers.value;
        const missingRequiredAssetsArray = await store_4.providersStore.getMissingRequiredAssets(providers, "provider");
        this.missingRequiredAssets = missingRequiredAssetsArray
            ? Array.from(missingRequiredAssetsArray)
            : [];
        ReactTooltip.rebuild();
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
        this.routeId = Number(this.props.params[0]);
        if (this.routeId > 0 && this.editId !== this.routeId) {
            this.isCollapse = false;
            this.editId = this.routeId;
        }
        if (this.props.params.length === 0) {
            this.isCollapse = true;
            this.editId = -1;
        }
        this.getIconProvider(); // 28/01/2025 missing icon 
    }
    // endregion
    // region Render methods
    render() {
        ReactTooltip.rebuild();
        return (React.createElement("div", { className: "providers" },
            React.createElement(ReactTooltip, { id: "warning-icon", className: "tooltip", effect: "solid", place: "left", "data-type": "warning", multiline: true }),
            store_3.usersStore.permissions.ReadProvider ? (React.createElement(React.Fragment, null,
                React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                    React.createElement("div", { className: "providers__title-wrapper" },
                        React.createElement(kpi_title_1.KpiTitle, { label: "Providers", subLabel: " " }),
                        store_3.usersStore.permissions.CreateProvider && ( // @TK allow site users to add/edit providers within their pharmacy.
                        React.createElement("div", { className: "floating-buttons", onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, tabIndex: 0 },
                            React.createElement(button_1.MaterialButton, { fab: true, secondary: true, className: "import-provider-btn", to: "/providers/import" },
                                React.createElement(Publish_1.default, null)),
                            React.createElement(button_1.MaterialButton, { fab: true, primary: true, className: "add-provider-btn", to: "/providers/0", onMouseEnter: this.onMouseEnter, onClick: () => (this.provider = ramda_1.merge(dummyProvider, {})) },
                                React.createElement(Add_1.default, null)))))),
                React.createElement(floating_page_1.FloatingPage, null, this.renderInfo()),
                React.createElement(ReactTooltip, { effect: "solid", place: "left" }),
                this.confirmDeleteProvider && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm and continue", cancelText: "Cancel and go back", message: `Are you sure you want to delete ${this.confirmDeleteProvider.prefix} ${this.confirmDeleteProvider.firstName} ${this.confirmDeleteProvider.lastName} ${this.confirmDeleteProvider.suffix}?`, onCancel: this.onHandleClickCancelDeleteProvider, onConfirm: this.onHandleClickConfirmDeleteProvider, title: "Are you sure you want to proceed?" })),
                this.uploadModal && this.confirmUploadProvider && (React.createElement(upload_modal_1.UploadModal, { onCancel: this.onHandleClickCancelUpload, message: `Please select files for ${this.confirmUploadProvider.prefix} ${this.confirmUploadProvider.firstName} ${this.confirmUploadProvider.lastName} ${this.confirmUploadProvider.suffix}.`, title: "Upload Documents", onDrop: this.handleAssetsUpload })))) : (store_3.usersStore.showLock())));
    }
    renderInfo() {
        const newProviderMode = this.props.params[0] === "0";
        const permissionToViewDisabled = store_3.usersStore.permissions.ViewDisabledSites;
        return (React.createElement("div", { className: "providers__data providerWrapper" },
            React.createElement("div", { className: "providers__data__list" },
                React.createElement(filter_header_1.FilterHeader, { label: "Search", title: "Providers", callBack: this.onCallback, withSwitch: permissionToViewDisabled, switchChecked: this.showDisabled, switchLabel: "Show Disabled", handleToggle: this.handleDisabledToggle, filterText: this.filterText }),
                newProviderMode && this.renderEditNewProvider(),
                this.renderList(),
                React.createElement("div", { className: "pagination-container-header" },
                    React.createElement("button", { className: "btn-pagination", disabled: this.page === 1 ? true : false, onClick: () => {
                            if (store_4.providersStore.currentPage == 1)
                                return;
                            this.page--;
                            this.loadProviders();
                        } }, "Previous"),
                    React.createElement("div", { className: "pagination-container" },
                        React.createElement("p", null, "Page"),
                        React.createElement("div", null,
                            React.createElement("div", { className: "cstmPaginationInput-Wrapper" },
                                React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "pagination-input", autoFocus: true, type: "text", 
                                    // min={1} 
                                    // max={providersStore.totalProviderPage} 
                                    onChange: (e) => {
                                        // C-097.271
                                        e.persist();
                                        const checkNegativeValue = e.target.value.charCodeAt(0);
                                        if (checkNegativeValue === 45) {
                                            return;
                                        }
                                        const value = Number(e.target.value);
                                        // this.page = Number(e.target.value);
                                        if (value >= 1 && value <= store_4.providersStore.totalProviderPage) {
                                            this.page = value;
                                        }
                                        else {
                                            if (e.target.value <= store_4.providersStore.totalProviderPage) {
                                                this.page = value;
                                            }
                                            else {
                                                e.target.value = this.page;
                                            }
                                        }
                                    }, onKeyDown: () => { }, onKeyDownEnterPress: this.handleKeyDown, value: this.page || "" }))),
                        React.createElement("div", null, "of"),
                        React.createElement("div", null, store_4.providersStore.totalProviderPage),
                        React.createElement("select", { className: "pagination-input", onChange: (e) => {
                                this.limit = Number(e.target.value);
                                this.loadProviders();
                                this.page = 1;
                                if (store_4.providersStore.totalProviderPage === store_4.providersStore.currentPage)
                                    return this.loadStartProviders();
                            }, defaultValue: this.limit },
                            React.createElement("option", { value: "5" }, "5 rows"),
                            React.createElement("option", { value: "10" }, "10 rows"),
                            React.createElement("option", { value: "25" }, "25 rows"),
                            React.createElement("option", { value: "50" }, "50 rows"),
                            React.createElement("option", { value: "100" }, "100 rows"))),
                    React.createElement("button", { className: "btn-pagination1", disabled: this.page === store_4.providersStore.totalProviderPage ? true : false, onClick: () => {
                            if (store_4.providersStore.currentPage >= store_4.providersStore.totalProviderPage)
                                return;
                            this.page++;
                            this.loadProviders();
                        } }, "Next")))));
    }
    renderList() {
        const { providers: { value: providers = [] } } = store_4.providersStore;
        // B-062.2
        this.allAssignedPharmacyProviders = providers.filter((item) => {
            var _a, _b;
            return (_b = (_a = store_3.usersStore === null || store_3.usersStore === void 0 ? void 0 : store_3.usersStore.user) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.sites.includes(item.sites[0].id);
        });
        // return (
        //   <div className="providers__data__list__info">
        //     {/*B-062.2 */}
        //       <MaterialList
        //         columns={columns}
        //         onRequestSort={this.onRequestSort}
        //         order={this.order}
        //         orderBy={this.orderBy}
        //         rows={usersStore.permissions.ReadProviders ? providers : this.allAssignedPharmacyProviders}
        //         renderRow={this.renderListRow}
        //         wideHeader={false}
        //         resizableheader
        //         customClass="custom-material-list__site-providers-list"
        //       />
        //   </div>
        // );
        return (React.createElement("div", { className: "providers__data__list__info" },
            React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: store_3.usersStore.permissions.ReadProviders
                    ? providers
                    : this.allAssignedPharmacyProviders, renderRow: this.renderListRow, wideHeader: false, resizableheader: true, customClass: "custom-material-list__site-providers-list providers__data__list__infosticky" //C-095.541
             })));
    }
};
__decorate([
    mobx_1.observable
], ProvidersList.prototype, "confirmDeleteProvider", void 0);
__decorate([
    mobx_1.observable
], ProvidersList.prototype, "confirmUploadProvider", void 0);
__decorate([
    mobx_1.observable
], ProvidersList.prototype, "sortedBy", void 0);
__decorate([
    mobx_1.observable
], ProvidersList.prototype, "editId", void 0);
__decorate([
    mobx_1.observable
], ProvidersList.prototype, "daysPrior", void 0);
__decorate([
    mobx_1.observable
], ProvidersList.prototype, "routeId", void 0);
__decorate([
    mobx_1.observable
], ProvidersList.prototype, "currentRowIndex", void 0);
__decorate([
    mobx_1.observable
], ProvidersList.prototype, "isCollapse", void 0);
__decorate([
    mobx_1.observable
], ProvidersList.prototype, "sortMenu", void 0);
__decorate([
    mobx_1.observable
], ProvidersList.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], ProvidersList.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], ProvidersList.prototype, "showUpload", void 0);
__decorate([
    mobx_1.observable
], ProvidersList.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], ProvidersList.prototype, "autoFocusForm", void 0);
__decorate([
    mobx_1.observable
], ProvidersList.prototype, "uploadModal", void 0);
__decorate([
    mobx_1.observable
], ProvidersList.prototype, "uploadType", void 0);
__decorate([
    mobx_1.observable
], ProvidersList.prototype, "storeProvider", void 0);
__decorate([
    mobx_1.observable
], ProvidersList.prototype, "missingRequiredAssets", void 0);
__decorate([
    mobx_1.observable
], ProvidersList.prototype, "showDisabled", void 0);
__decorate([
    mobx_1.observable
], ProvidersList.prototype, "page", void 0);
__decorate([
    mobx_1.observable
], ProvidersList.prototype, "limit", void 0);
__decorate([
    mobx_1.observable
], ProvidersList.prototype, "totalPages", void 0);
ProvidersList = __decorate([
    mobx_react_1.observer
], ProvidersList);
exports.ProvidersList = ProvidersList;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/providers/modules/providers-list/providers-list.tsx
// module id = 3852
// module chunks = 0